import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sanitize } from '../../tools/serialisation/sanitize';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { toStackTraceString } from '../../tools/stackTrace/handlingStack';
import { isIndexableObject } from '../../tools/utils/typeUtils';
export var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeErrorBase(_ref) {
  var originalError = _ref.originalError,
    stackTrace = _ref.stackTrace,
    source = _ref.source,
    _ref$useFallbackStack = _ref.useFallbackStack,
    useFallbackStack = _ref$useFallbackStack === void 0 ? true : _ref$useFallbackStack,
    nonErrorPrefix = _ref.nonErrorPrefix;
  var isErrorInstance = isError(originalError);
  if (!stackTrace && isErrorInstance) {
    stackTrace = computeStackTrace(originalError);
  }
  return {
    source: source,
    type: stackTrace ? stackTrace.name : undefined,
    message: computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
    stack: stackTrace ? toStackTraceString(stackTrace) : useFallbackStack ? NO_ERROR_STACK_PRESENT_MESSAGE : undefined
  };
}
export function computeRawError(_ref2) {
  var stackTrace = _ref2.stackTrace,
    originalError = _ref2.originalError,
    handlingStack = _ref2.handlingStack,
    componentStack = _ref2.componentStack,
    startClocks = _ref2.startClocks,
    nonErrorPrefix = _ref2.nonErrorPrefix,
    _ref2$useFallbackStac = _ref2.useFallbackStack,
    useFallbackStack = _ref2$useFallbackStac === void 0 ? true : _ref2$useFallbackStac,
    source = _ref2.source,
    handling = _ref2.handling;
  var errorBase = computeErrorBase({
    originalError: originalError,
    stackTrace: stackTrace,
    source: source,
    useFallbackStack: useFallbackStack,
    nonErrorPrefix: nonErrorPrefix
  });
  return _objectSpread(_objectSpread({
    startClocks: startClocks,
    handling: handling,
    handlingStack: handlingStack,
    componentStack: componentStack,
    originalError: originalError
  }, errorBase), {}, {
    causes: isError(originalError) ? flattenErrorCauses(originalError, source) : undefined,
    fingerprint: tryToGetFingerprint(originalError),
    context: tryToGetErrorContext(originalError)
  });
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
  // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
  // TODO rework tracekit integration to avoid scattering error building logic
  return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? nonErrorPrefix ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError))) : jsonStringify(sanitize(originalError)) : 'Empty message';
}
export function tryToGetFingerprint(originalError) {
  return isError(originalError) && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
export function tryToGetErrorContext(originalError) {
  if (isIndexableObject(originalError)) {
    return originalError.dd_context;
  }
}
export function getFileFromStackTraceString(stack) {
  var _a;
  return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
export function isError(error) {
  return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
}
export function flattenErrorCauses(error, parentSource) {
  var causes = [];
  var currentCause = error.cause;
  while (currentCause !== undefined && currentCause !== null && causes.length < 10) {
    var causeBase = computeErrorBase({
      originalError: currentCause,
      source: parentSource,
      useFallbackStack: false
    });
    causes.push(causeBase);
    currentCause = isError(currentCause) ? currentCause.cause : undefined;
  }
  return causes.length ? causes : undefined;
}